export default function (Component, fallback = 'Component') {
  if (!Component) {
    return fallback;
  }
  return Component.displayName || Component.name || Component.type && (Component.type.displayName || Component.type.name) || fallback;
}